import React from 'react';
import './MaintenanceMessage.css';

const MaintenanceMessage = () => {
  return (
    <div className="maintenance-message">
      <p>
        <strong>Notice:</strong> ASPPH-hosted websites will undergo scheduled maintenance on{' '}
        <strong>Friday, January 2, 2026 from 8:00-9:00am ET.</strong> During this window, some
        services may be temporarily unavailable.
      </p>
    </div>
  );
};

export default MaintenanceMessage;
